module.exports = __webpack_public_path__ + "img/pirate-fountain_2.8283bd95.jpg";